import * as React from 'react'
import { Buttons, FormFieldWrapper, LabelFormField, TextFormField, Tooltip } from 'traveldesk-ui'
import VideoDisplay from './VideoDisplay'
import { useSelector } from 'react-redux'
import { ApplicationState } from '../../store'

interface Props {
    videoUrls: string
    onChangeVideosUrls: (urls: string) => void
}
export class VideoManagerItem {
    constructor(url: string, type: VideoManagerVideoType, isHero: boolean) {
        this.url = url
        this.type = type
        this.isHero = isHero
    }
    public static IsKnown(url: string) {
        return url.indexOf("youtube.com") >= 0 || url.indexOf("vk.com") >= 0 || url.indexOf("vkvideo") >= 0 || url.indexOf("vimeo")
    }
    public static Parse(url: string, isHero: boolean) {
        if (url.indexOf("vk.com") >= 0 || url.indexOf("vkvideo") >= 0) {
            return new VideoManagerItem(url, VideoManagerVideoType.VK, isHero)
        }
        else {
            return new VideoManagerItem(url, VideoManagerVideoType.Youtube, isHero)
        }
    }
    url: string = ''
    type: VideoManagerVideoType = VideoManagerVideoType.NotSet
    isHero: boolean = false
}
export enum VideoManagerVideoType {
    NotSet, Youtube, VK, Vimeo
}
export const VideoManager = (props: Props) => {
    const Localization = useSelector((state: ApplicationState) => state.localization.locale)
    const [videos, setVideos] = React.useState<VideoManagerItem[]>([])
    React.useEffect(() => {
        let _videos = [] as VideoManagerItem[]
        if (props.videoUrls && props.videoUrls.length > 0) {
            const vEncs = props.videoUrls.split("||")
            _videos = vEncs.map(v => {
                const _vDetails = v.split("|")
                if (_vDetails.length == 1) { //fallback to prev version
                    return new VideoManagerItem(_vDetails[0], VideoManagerVideoType.Youtube, true)
                }
                else {
                    return new VideoManagerItem(_vDetails[0], parseInt(_vDetails[1]), _vDetails.length > 2)
                }
            })
        }
        // _videos.push(new VideoManagerItem("", VideoManagerVideoType.NotSet))
        setVideos(_videos)
    }, [props.videoUrls])
    const updateVideos = (videos: VideoManagerItem[]) => [
        props.onChangeVideosUrls(videos.map(v => {
            let _v = `${v.url}|${v.type}`
            if (v.isHero) {
                _v += "|1"
            }
            return _v
        }).join("||"))
    ]
    const onAdd = () => {
        videos.push(new VideoManagerItem("", VideoManagerVideoType.NotSet, videos && videos.some(x => x.isHero) ? false : true))
        updateVideos(videos)
    }
    const onDelete = (index: number) => {
        const _videos = videos.filter((v, i) => index != i)
        if (!_videos.some(x => x.isHero) && _videos.length > 0) {
            _videos[0].isHero = true
        }
        updateVideos(_videos)
    }
    const onSetHero = (index: number) => {
        if (videos.length > 1) {
            const _videos = videos.map((v, i) => new VideoManagerItem(v.url, v.type, i == index))
            updateVideos(_videos)
        }
    }
    const onChange = (index: number, urlPrev: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
        const url = e.target.value
        if (VideoManagerItem.IsKnown(url)) {
            const isHeroByDefault = videos.length == 1;
            const _videos = videos.map((v, i) => i == index ? VideoManagerItem.Parse(url, v.isHero || isHeroByDefault) : v)
            updateVideos(_videos)
        }
        else {
            updateVideos(videos)
        }
    }
    return <>
        <Tooltip text={Localization.getString('Add video')}>
            <Buttons.ButtonSmallGreen onClick={onAdd}>
                <i className="fa fa-plus" />
            </Buttons.ButtonSmallGreen>
        </Tooltip>
        <br /><br />
        {videos.map((v, index) => {
            return <FormFieldWrapper key={`${v.url}-${index}`}>
                <i style={{ padding: '5px' }} className='float-right fa fa-trash clickable' onClick={() => onDelete(index)} />
                <i style={{ padding: '5px' }} className={`float-right fa fa-star${v.isHero ? " warning" : " clickable"}`} onClick={() => { if (!v.isHero) { onSetHero(index) } }} />
                <label>Video #{index + 1}</label>
                <input type="text" value={v.url} onChange={onChange(index, v.url)} autoComplete="off" placeholder="Please share youtube, vk or vimeo URL' s only" />
                {/* <TextFormField
                    subLabel={Localization.getString("Please share youtube, vk or vimeo URL's only")}
                    label={Localization.getString('Video Url')}
                    value={v.url}
                    onChange={onChange(index, v.url)}
                /> */}
                <VideoDisplay video={v} />
            </FormFieldWrapper>
        })}
        {videos && videos.length > 0
            ? <Tooltip text={Localization.getString('Add video')}>
                <Buttons.ButtonSmallGreen onClick={onAdd}>
                    <i className="fa fa-plus" />
                </Buttons.ButtonSmallGreen>
            </Tooltip>
            : undefined}
        <br /><br />
    </>
}